export default __webpack_public_path__ + "static/google-play-b4505f67b5042cd34924746273cf156a.png";